import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './Pages/LandingPage';
import { AuthProvider } from "./auth/AuthContext";
import About from "./Pages/About";
import AppLayout from "./AppLayout";
import Neighborhoods from "./Pages/Neighborhoods";
import Contact from "./Pages/Contact";
import Reviews from "./Pages/Reviews";
import Buyers from "./Pages/Buyers";
import Sellers from "./Pages/Sellers";
import BlogPostPage from "./Pages/BlogPostPage";
import BlogIndexPage from "./Pages/BlogIndexPage";
import ListingsAdmin from "./Pages/ListingsAdmin";
import ReviewsAdmin from "./Pages/ReviewsAdmin";
import Listings from "./Pages/Listings";
import DevDb from "./Pages/DevDb";



function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<AppLayout />}>
            {/* PUBLIC ROUTES */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/neighborhoods" element={<Neighborhoods />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/buyers" element={<Buyers />} />
            <Route path="/sellers" element={<Sellers />} />
            <Route path="/blog" element={<BlogIndexPage/>} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin-kyhomes-listings" element={<ListingsAdmin />} />
            <Route path="/admin-kyhomes-reviews" element={<ReviewsAdmin />} />
            <Route path="/dev-db-nts" element={<DevDb />} />
            <Route path="/listings" element={<Listings />} />

            <Route path="*" element={<h2>404: Page Not Found</h2>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>

  );
}

export default App;
